import * as React from "react";
const SvgTriangle = (props) => /* @__PURE__ */ React.createElement("svg", { width: 6, height: 11, viewBox: "0 0 6 11", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M-2.40413e-07 5.5L6 6.91406e-07L6 11L-2.40413e-07 5.5Z", fill: "#352626" }));
export default SvgTriangle;
